import keys from 'lodash/keys';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { teamName, packageName } from '../../common/constants.tsx';
import type { FetchProformaReqTypeConfigParams, ProformaReqTypeConfig } from '../../types.tsx';
import {
	fetchProformaReqTypeFormData,
	type ProformaReqTypeFormDataResponse,
} from './fetch-rt-form-data/index.tsx';

const transform = (
	proformaRTFormDataResponse: ProformaReqTypeFormDataResponse,
): ProformaReqTypeConfig => {
	const {
		formId,
		formName,
		fields,
		newIssueRequestTypeIds,
		newIssueIssueTypeIds,
		restrictionStatus,
	} = proformaRTFormDataResponse;
	const proformaReqTypeConfig = {
		formId,
		formName,
		linkedFieldsKey: keys(fields),
		markedForRemoval: false,
		usedAsIssueForm: newIssueIssueTypeIds.length > 0 || newIssueRequestTypeIds.length > 0,
		restrictionStatus: fg('granular_permissions_on_forms_m1') ? restrictionStatus : undefined,
	};

	return { ...proformaReqTypeConfig, linkedFields: proformaRTFormDataResponse.fields };
};

const sendErrorAnalyticsEvent = (projectId: number, requestTypeId: number, error: Error) => {
	fireErrorAnalytics({
		meta: {
			id: 'fetchProformaReqTypeForm',
			packageName,
			teamName,
		},
		error,
		attributes: {
			projectId,
			requestTypeId,
		},
	});
};

export const fetchProformaReqTypeConfig: (
	arg1: FetchProformaReqTypeConfigParams,
) => Promise<ProformaReqTypeConfig | null> = async ({ cloudId, projectId, requestTypeId }) => {
	try {
		const proformaRTFormDataResponse: ProformaReqTypeFormDataResponse | null =
			await fetchProformaReqTypeFormData({
				cloudId,
				projectId,
				requestTypeId,
			});

		if (proformaRTFormDataResponse) {
			return transform(proformaRTFormDataResponse);
		}

		return null;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		sendErrorAnalyticsEvent(projectId, requestTypeId, error);
		return null;
	}
};
